export default {
  state: {
    listflag: {
      cpflag: true,
      znflag: false,
      hsflag: false,
      hsvrflag: false,
      hlwflag: false
    },
    headerTitle:{
      showindex:true,
      showabout:false,
      showproduct:false,
      shownews:false,
      showjoin:false,
      showpartner:false,
      showcontact:false,
      showlanguage:false,
    }
  },
  getters: {
    Getlistflag: state => {
      return state.cpflag
    },
    getHeaderTitle: state => {
      return state.headerTitle
    }
  },
  mutations: {
    Setlistflag (state, cpflag) {
      state.shipflag = cpflag
    },
    setHeaderTitle(state,headerTitle){
      state.headerTitle = headerTitle;
      localStorage.setItem('header',JSON.stringify(headerTitle))
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/model_pramers.js